import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { DatePicker, DateRangePicker } from "rsuite";
import {
  checkUserAccess,
  getCurrentFinancialYear,
  printData,
} from "../../utility/CommonFunctions";
import moment from "moment";
import { Input, Spinner } from "reactstrap";
import { useEffect } from "react";
import { useState } from "react";
import BackArrowIcon from "../Icons/BackArrowIcon";
import { updateFiltersStates } from "../../store/actions/UserActions";
import SearchSiteSelect from "./SiteSearchSelect";

export default function MainHeading({
  showBackButton,
  title,
  buttonText,
  buttonLink,
  buttonIcon,
  buttonLoader,
  state,
  clickHandler,
  dateChangeHandler,
  showDefaultDate,
  singleDateChangeHandler,
  handleYearChange,
  sites,
  office,
  setPageStates,
  pageState = null,
  getSite = () => Promise.resolve([]),
  pickerType = "date",
  monthChangeHandler,
  selectedMonth,
  children
}) {
  const navigate = useNavigate();
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const dateFilter = useSelector((state) => state.root.months);
  const dispatch = useDispatch();
  const now = new Date();
  // Generate financial years list dynamically
  const today = moment();
  const [resetYear, setResetYear] = useState(filterDetails?.sortByDate);
  const currentYear = today.month() < 3 ? today.year() - 1 : today.year();
  const financialYears = [];
  for (let i = 2023; i <= currentYear + 3; i++) {
    financialYears.push(`${i}-${i + 1}`);
  }

  const [selectedYear, setSelectedYear] = useState(getCurrentFinancialYear());

  useEffect(() => {
    setResetYear(
      filterDetails?.sortByDate?.length == 0
        ? [
          moment(moment().subtract(30, "days").toDate()).format("YYYY-MM-DD"),
          moment(moment().toDate()).format("YYYY-MM-DD"),
        ]
        : filterDetails?.sortByDate
    );
    if (handleYearChange) {
      handleYearChange(selectedYear);
    }
  }, []);

  const onYearChange = (e) => {
    const newYear = e.target.value;
    setSelectedYear(newYear);
    handleYearChange(newYear);
    setResetYear(null);
  };

  // printData(filterDetails?.sortByDate)

  return (
    <>
      <div className="content-head d-flex align-items-start justify-content-between">
        <div className="d-flex gap-3">
          {showBackButton && (
            <button className="btn back-arrow" onClick={() => navigate(-1)}>
              <BackArrowIcon />
            </button>
          )}
          <div className="mb-0">
            <div className="d-inline-block">
              <h3 className="fw-medium text-dark mb-1 fs-4">{title}</h3>

              <div
                style={{
                  height: "4px",
                  width: "100%",
                  borderRadius: "10px",
                  marginTop: "4px",
                  background: "linear-gradient(90deg, #1E6AE5, #b1d3feff)",
                }}
              ></div>
            </div>
          </div>

        </div>
        <div className="d-flex align-items-center gap-3">
          {handleYearChange && (
            <Input
              style={{ width: "12rem" }}
              type="select"
              role="button"
              value={selectedYear}
              onChange={(e) => onYearChange(e)}
              className="form-select-sm bg-white fs-5"
            >
              {financialYears.map((year, index) => (
                <option key={index} value={year}>
                  {year}
                </option>
              ))}
            </Input>
          )}

          {monthChangeHandler && (
            <Input
              style={{ width: "12rem" }}
              type="select"
              role="button"
              value={selectedMonth}
              onChange={(e) => monthChangeHandler(e.target.value)}
              className="form-select-sm bg-white fs-5"
            >
              <option value="">All Months</option>
              <option value="january">January</option>
              <option value="february">February</option>
              <option value="march">March</option>
              <option value="april">April</option>
              <option value="may">May</option>
              <option value="june">June</option>
              <option value="july">July</option>
              <option value="august">August</option>
              <option value="september">September</option>
              <option value="october">October</option>
              <option value="november">November</option>
              <option value="december">December</option>
            </Input>
          )}

          {(sites || office) && (
            <div className="dashboard-search-box" style={{ width: "28rem" }}>
              <SearchSiteSelect
                className=""
                value={filterDetails?.siteId}
                options={sites}
                onSelect={(value) => {
                  dispatch(
                    updateFiltersStates({
                      siteId: value?.value,
                    })
                  );
                  // console.log(value);
                  // console.log(sites);
                }}
                onSearch={(input) => getSite(2, input)}
                isLoading={pageState?.isLoadingSite}
                placeholder={"Search Site"}
              />
            </div>
          )}

          {dateChangeHandler && (
            <div>
              <DateRangePicker
                size="sm"
                format="dd/MM/yyyy"
                placeholder="From - To"
                placement="auto"
                defaultValue={
                  showDefaultDate
                    ? [
                      moment().subtract(30, "days").toDate(),
                      moment().toDate(),
                    ]
                    : []
                }
                value={
                  resetYear?.length === 2
                    ? [new Date(resetYear[0]), new Date(resetYear[1])]
                    : []
                }
                onChange={(value) => {
                  setResetYear(value);
                  dateChangeHandler(value);
                }}
              />
            </div>
          )}
          {/* {dateChangeHandler && (
            <div>
              <DateRangePicker
                size="md"
                format="dd/MM/yyyy"
                placeholder="From - To"
                placement="auto"
                value={dateRange}
                onChange={(dates) => {
                  if (!dates || dates.length === 0) {
                    // Reset to current financial year when cleared
                    const currentYearDates =
                      getFinancialYearDates(selectedYear);
                    setDateRange(currentYearDates);
                    dateChangeHandler(currentYearDates);
                  } else {
                    setDateRange(dates);
                    dateChangeHandler(dates);
                  }
                }}
                shouldDisableDate={(date) =>
                  (minDate && date < minDate) || (maxDate && date > maxDate)
                } //  Restricts date selection
                cleanable // Allows clearing with the "X" button
              />
            </div>
          )} */}

          {singleDateChangeHandler && (
            <div className="">
              {/* <DatePicker size="sm"
                format="dd/MM/yyyy"
                placeholder="Select Date"
                placement="auto"
                defaultValue={new Date()}
                onChange={singleDateChangeHandler}
              /> */}
              <DatePicker size="sm"
                format={pickerType === "month" ? "MM/yyyy" : "dd/MM/yyyy"}
                placeholder={
                  pickerType === "month" ? "Select Month" : "Select Date"
                }
                placement="auto"
                defaultValue={new Date(dateFilter?.[0])}
                value={
                  pageState?.sortBySingleDate
                    ? new Date(pageState?.sortBySingleDate?.[0])
                    : new Date(dateFilter?.[0])
                }
                onChange={singleDateChangeHandler}
                cleanable={false}
                shouldDisableDate={(date) => date > new Date()}
                oneTap
                calendardefaulttype={pickerType === "month" ? "month" : "date"}
              />
            </div>
          )}

          {buttonLink && (
            <Link
              to={buttonLink}
              state={state}
              className="btn btn-outline-primary px-5"
            >
              <span>{buttonIcon}</span>
              {buttonText}
            </Link>
          )}

          {clickHandler && (
            <button
              onClick={clickHandler}
              className="btn btn-outline-primary px-5"
            >
              {buttonLoader ? <Spinner /> : <span>{buttonIcon}</span>}
              {buttonText}
            </button>
          )}
          {children}
        </div>
      </div>
    </>
  );
}